import React from "react";

export default function TivBanner({ isPremium, paidTiv, onOpenPremium }) {
  if (paidTiv) return null;

  if (isPremium) {
    return (
      <div className="bg-white/[0.03] border border-white/[0.06] rounded-2xl p-4 mb-5 border border-l-4 border-l-amber-400">
        <span className="text-[11px] font-bold text-amber-600 uppercase tracking-[0.8px]">Nouveau</span>
        <h2 className="text-[17px] font-bold text-[var(--color-text-primary)] mt-1.5 mb-2">
          Tiv est disponible
        </h2>
        <p className="text-[13px] text-[var(--color-text-secondary)] leading-relaxed mb-4">
          Tiv t'aide à rédiger des lettres de motivation percutantes pour tes vœux Parcoursup. Personnalisées, adaptées à ton profil.
        </p>
        <button
          onClick={onOpenPremium}
          className="bg-[var(--color-premium)] text-[var(--color-text-button)] text-[13px] font-semibold px-4 py-2 rounded-[10px] border-0 cursor-pointer"
        >
          Demande à tes parents pour débloquer Tiv
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white/[0.03] border border-white/[0.06] rounded-2xl p-4 mb-5 border border-l-4 border-l-amber-400">
      {/* <span className="text-[11px] font-bold text-amber-600 uppercase tracking-[0.8px]">Offre de lancement</span> */}
      <h2 className="text-[17px] font-bold text-[var(--color-text-primary)] mt-1.5 mb-2">
        Tiv est disponible
      </h2>
      <p className="text-[13px] text-[var(--color-text-secondary)] leading-relaxed mb-1.5">
        Tiv t'aide à rédiger tes lettres de motivation Parcoursup. Disponible avec Oria Premium.
      </p>
      {/* <p className="text-[13px] font-semibold text-amber-600 mb-4">
        Offre de lancement jusqu'au dimanche 22 mars à minuit : 9€ au lieu de 19€ pour toute l'application.
      </p> */}
      <button
        onClick={onOpenPremium}
        className="bg-[var(--color-premium)] text-[var(--color-text-button)] text-[13px] font-semibold px-4 py-2 rounded-[10px] border-0 cursor-pointer"
      >
        Demande à tes parents pour débloquer Oria Premium
      </button>
    </div>
  );
}
